import React from 'react';
import { Container } from 'reactstrap';
import { DataTable, Column } from 'vivace-fluent-motion';
import IntlMessage from '../../../helpers/intlMessage';

function LaminasHistologia ({ lista }) {

  function RenderizarFooter({ total, text }) {
    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <i className="mv-basico-stacktrace" style={{ fontSize: '20px', height: '-150px' }}/>{' '}
          <span style={{marginTop: '2px', fontSize: '14px'}} id="total-exames">
            {text}: {total} <IntlMessage id="dashboards.disposalMaterials.table.items"/>
          </span>
        </span>
      </div>
    );
  }

  return (
    <Container fluid className='mv-workspace-container'>
      <DataTable
        value={lista}
        responsive={true}
        selectionMode='single'
        style={{height: '70vh'}}
        columnResizeMode='expand'
        scrollable={true}
        scrollHeight='71vh'
        scrollWidth='100%'
        resizableColumns={true}
        reorderableColumns={true}
        rowsPerPageOptions={[10, 20, 50]}
        lazy={false}
        paginator={false}
        emptyMessage={<IntlMessage id = "dashboards.taskControl.noResult"/>}
        footer={<RenderizarFooter text={'Total'} total={lista.length}/>}
        alwaysShowPaginator={true}
        autoLayout={true}
        totalRecords={lista.length}
        onSelectionChange={e => {}}
      >
        <Column sortable={true} field='nrLamina' style={{width: '100px'}} header={<IntlMessage id="dashboards.taskControl.blade"/>}/>
        <Column sortable={true} field='tipoLamina' style={{width: '100px'}} header={<IntlMessage id="dashboards.taskControl.bladeType"/>}/>
        <Column sortable={true} field='nomePaciente' style={{width: '180px'}} header={<IntlMessage id="dashboards.taskControl.patient"/>}/>
        <Column sortable={true} field='pacienteNomeSocial' style={{width: '180px'}} header={<IntlMessage id="dashboards.general.socialName"/>}/>
        <Column sortable={true} field='nomeTecnico' style={{width: '180px'}} header={<IntlMessage id="dashboards.examDetail.table.technician"/>}/>
        <Column sortable={true} field='medicoNome' style={{width: '180px'}} header={<IntlMessage id="dashboards.taskControl.pathologistDoctor"/>}/>
        <Column sortable={true} field='coloracao' style={{width: '80px'}} header={<IntlMessage id="dashboards.taskControl.coloring"/>}/>
        <Column sortable={true} field='finalizacao' style={{width: '70px'}} header={<IntlMessage id="dashboards.taskControl.status"/>}/>
        <Column sortable={true} field='cancelada' style={{width: '70px'}} header={<IntlMessage id="dashboards.taskControl.canceled"/>}/>
      </DataTable>
    </Container>
  );
}

export default LaminasHistologia;



// WEBPACK FOOTER //
// ./src/pages/controleTarefas/Histologia/index.js